import React, { useEffect, useRef } from "react";

import ProfileTabs from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/ProfileTabs";
import PatientProfileForm from "components/pages/transmissions/modal/patient/tabs/generalInformation/profile/ProfileForm";
import TransmissionForm from "components/pages/transmissions/modal/patient/tabs/generalInformation/transmission/TransmissionForm";
import BillingSchedule from "components/pages/transmissions/modal/patient/tabs/generalInformation/billingSchedule/BillingSchedule";
import PatientInformation from "components/pages/transmissions/modal/patient/tabs/generalInformation/patientInformation/PatientInformation";
import { useSelector } from "react-redux";
import PatientNotes from "./patientInformation/patientNotes/patientNotes";

const GeneralInformation = () => {
  const patientInfoRef = useRef(null);
  const { showMissingContactInfo } = useSelector((state) => state.patient);

  useEffect(() => {
    if (patientInfoRef.current && showMissingContactInfo) {
      patientInfoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showMissingContactInfo]);

  return (
    <main className="patient-modal__main">
      <PatientProfileForm />
      <TransmissionForm />
      <BillingSchedule />
      <ProfileTabs />
      <PatientInformation ref={patientInfoRef} />
      <PatientNotes />
    </main>
  );
};
export default GeneralInformation;
